var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"omapi-progress-bar"},_vm._l((_vm.total),function(index){return _c('div',{key:index,staticClass:"omapi-progress-bar__step",class:{'omapi-progress-bar__step-active': _vm.isActive(index)}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }